import { defineStore } from "pinia";

interface INotification {
    id: string;
    message: string;
    title: string;
    type: "success" | "error";
}

export const useNotificationStore = defineStore("notificationStore", {
  state: () => ({
    notifications: [] as INotification[],
   }),
  actions: {
    addNotification(notification: INotification) {
        notification.id = generateId();
        this.notifications.push(notification);
    },
    removeNotification(id: string) {
        this.notifications = this.notifications.filter((n) => n.id !== id);
    },
  },
});

function generateId() {
  return Math.random().toString(36).substring(2, 9);
}